import { branding } from '../../config/branding';

const DEFAULT_SUPPORT_WHATSAPP = '05402338467';
const DEFAULT_SUPPORT_EMAIL = 'support@siateknoloji.com';
const DEFAULT_SUPPORT_MANUAL_URL = '/usermanual';
export const supportTitle = `${branding.shortName} Destek`;

function normalizePhoneDigits(value: string) {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return '';
  // Etkinlik ayarından +971... gibi uluslararası numara gelebilir: olduğu gibi bırak.
  if (trimmed.startsWith('+')) return digits;
  if (digits.startsWith('90')) return digits;
  if (digits.startsWith('0')) return `90${digits.slice(1)}`;
  if (digits.startsWith('5')) return `90${digits}`;
  return digits;
}

function formatTurkishPhoneDisplay(value: string) {
  if (value.trim().startsWith('+') && !value.replace(/\D/g, '').startsWith('90')) return value.trim();
  const digits = value.replace(/\D/g, '');
  const local = digits.startsWith('90') ? digits.slice(2) : digits.startsWith('0') ? digits.slice(1) : digits;
  if (local.length === 10) {
    return `0${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8, 10)}`;
  }
  return value;
}

export const supportWhatsappRaw = String(
  process.env.REACT_APP_SUPPORT_WHATSAPP || DEFAULT_SUPPORT_WHATSAPP,
).trim();

export const supportEmail = String(
  process.env.REACT_APP_SUPPORT_EMAIL || DEFAULT_SUPPORT_EMAIL,
).trim();

export const supportManualUrl = String(
  process.env.REACT_APP_SUPPORT_MANUAL_URL || DEFAULT_SUPPORT_MANUAL_URL,
).trim();

export type SupportContact = {
  whatsappDigits: string;
  whatsappDisplay: string;
  email: string;
  manualUrl: string;
  links: { whatsapp: string; email: string; manual: string };
};

/** Etkinlikte tanımlı destek bilgisi (boş alan → ortam değişkenindeki varsayılan). */
export type SupportOverrides = { phone?: string | null; email?: string | null } | null | undefined;

export function buildSupportContact(overrides?: SupportOverrides): SupportContact {
  const phoneRaw = String(overrides?.phone ?? '').trim() || supportWhatsappRaw;
  const email = String(overrides?.email ?? '').trim() || supportEmail;
  const whatsappDigits = normalizePhoneDigits(phoneRaw);
  return {
    whatsappDigits,
    whatsappDisplay: formatTurkishPhoneDisplay(phoneRaw),
    email,
    manualUrl: supportManualUrl,
    links: {
      whatsapp: whatsappDigits
        ? `https://wa.me/${whatsappDigits}?text=${encodeURIComponent('Merhaba, destek almak istiyorum.')}`
        : '#',
      email: email ? `mailto:${email}?subject=${encodeURIComponent(supportTitle)}` : '#',
      manual: supportManualUrl || '#',
    },
  };
}

const defaultSupportContact = buildSupportContact();

export const supportWhatsappDigits = defaultSupportContact.whatsappDigits;
export const supportWhatsappDisplay = defaultSupportContact.whatsappDisplay;
export const supportLinks = defaultSupportContact.links;

export function hasAnySupportLink(contact: SupportContact = defaultSupportContact) {
  return Boolean(contact.whatsappDigits || contact.email || contact.manualUrl);
}

export function openPreferredSupportChannel(contact: SupportContact = defaultSupportContact) {
  if (typeof window === 'undefined') {
    return false;
  }

  if (contact.whatsappDigits && contact.links.whatsapp !== '#') {
    window.open(contact.links.whatsapp, '_blank', 'noopener,noreferrer');
    return true;
  }

  if (contact.email && contact.links.email !== '#') {
    window.location.href = contact.links.email;
    return true;
  }

  if (contact.manualUrl && contact.links.manual !== '#') {
    window.open(contact.links.manual, '_blank', 'noopener,noreferrer');
    return true;
  }

  return false;
}
